import React from 'react';
import { connect } from "react-redux";
import GenericInput from '../../common/input/GenericInput';
import LocationSearchInput from '../../common/input/LocationSearchInput';
import Select from '../../common/input/select';
import PhoneNumber from '../../common/input/PhoneNumber';
import Email from '../../common/input/Email';
import RxNumber from "../../common/RxNumber";
import ZipCode from "../../common/input/ZipInput";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import * as ProxyHelper from "../ProxyHelper";

const firstNameInputId = "firstNameInput";
const middleNameInputId = "middleNameInput";
const lastNameInputId = "lastNameInput";
const phoneInputId = 'phoneInput';
const rxNumberInputId = 'rxNumberInput';
const addressInputId = "addressInput";
const relationInputId = "relationInput";
const emailInputId = "emailInput";

const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' }
];

class ProxyInfo extends React.Component {
    constructor(props) {
        super(props);
        const { proxyRequestData } = this.props; //if its retry option selected on failure        
        const { firstName, middleName, lastName, mailingAddress, relationship, phone, email, rxNumber, zipCode, gender } = proxyRequestData;

        this.state = {
            fName: firstName,
            mName: middleName,
            lName: lastName,
            mAddress: mailingAddress,
            rStatus: relationship,
            pNumber: phone,
            email: email,
            rNumber: rxNumber,
            zip: zipCode,
            Zip: zipCode,
            gender,
            confirmEmail: email
        };
        this.notifyToEnterAddressManually = this.notifyToEnterAddressManually.bind(this);
    }

    componentDidMount() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.ProxyInfo.ComponentDidMount${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    onGoBack() {
        this.setState({ showAsInvalid: false });
        const { proxyRequestData } = this.props;
        if (this.props.onGoNext) {
            this.props.onGoNext(true, { ...proxyRequestData, documentSubmitted: false });
        }
    }

    onGoNext(success) {
        let proxyRequestData = null;
        const { pharmacy, healthrecord, isMinor, onSubmit } = this.props;
        if (success) {
            const { fName, lName, zip, rNumber, pNumber, rStatus, mAddress, mName, email, gender } = this.state;
            let zipCode = '';
            if (healthrecord && pharmacy) { //if both options selected get zip code from mailing address
                zipCode = (mAddress && mAddress.zip) ? mAddress.zip : '';
            }
            else if (pharmacy) {
                zipCode = zip;
            }
            proxyRequestData = {
                firstName: fName, lastName: lName, dob: this.props.dob, zipCode: zipCode,
                rxNumber: rNumber, phone: pNumber, relationship: rStatus, email: email, mailingAddress: mAddress, middleName: mName, gender
            };

            /*if (pharmacy && !healthrecord && !isMinor && onSubmit)
                onSubmit(proxyRequestData);*/
            if (this.props.onGoNext) {
                this.props.onGoNext(success, proxyRequestData);
            }
        }
        else {
            this.setState({ showAsInvalid: true });
        }

    }

    isValid() {
        return this.validateForm();

    }

    fieldsOnScreen = () => {
        const { isMinor, pharmacy, healthrecord, isShowManualAddress, enableProxyRequestV2, proxyRequestData } = this.props;
        const fields = [];
        if (isMinor) {
            if (pharmacy && !healthrecord) {
                Array.prototype.push.apply(fields, ["fName", "lName", "rStatus", "pNumber", "rNumber", "zip"]);
            }
            else if (!pharmacy && healthrecord) {
                isShowManualAddress ? Array.prototype.push.apply(fields, ["fName", "lName", "StreetNumber", "Street", "City", "State", "Zip", "rStatus", "gender"]) : Array.prototype.push.apply(fields, ["fName", "lName", "mAddress", "rStatus", "gender"]);
            }
            else if (pharmacy && healthrecord) {
                isShowManualAddress ? Array.prototype.push.apply(fields, ["fName", "lName", "StreetNumber", "Street", "City", "State", "Zip", "rStatus", "pNumber", "rNumber", "gender"]) : Array.prototype.push.apply(fields, ["fName", "lName", "mAddress", "rStatus", "pNumber", "rNumber", "gender"]);
            }
        }
        else {
            if (pharmacy && !healthrecord) {
                Array.prototype.push.apply(fields, ["fName", "lName", "rStatus", "pNumber", "rNumber", "zip", "email"]);
            }
            else if (!pharmacy && healthrecord) {
                if (enableProxyRequestV2 && proxyRequestData.manageOwnHealthcare) {
                    Array.prototype.push.apply(fields, ["fName", "lName", "email"]);
                }
                else
                    isShowManualAddress ? Array.prototype.push.apply(fields, ["fName", "mName", "lName", "pNumber", "email", "rStatus", "StreetNumber", "Street", "City", "State", "Zip", "gender"]) : Array.prototype.push.apply(fields, ["fName", "mName", "lName", "pNumber", "email", "mAddress", "rStatus", "gender"]);
            }
            else if (pharmacy && healthrecord) {
                if (enableProxyRequestV2 && proxyRequestData.manageOwnHealthcare) {
                    Array.prototype.push.apply(fields, ["fName", "lName", "zip", "rStatus", "pNumber", "email", "rNumber"]);
                }
                else
                    isShowManualAddress ? Array.prototype.push.apply(fields, ["fName", "mName", "lName", "pNumber", "rStatus", "rNumber", "email", "StreetNumber", "Street", "City", "State", "Zip", "gender"]) : Array.prototype.push.apply(fields, ["fName", "mName", "lName", "pNumber", "rStatus", "rNumber", "email", "mAddress", "gender"]);
            }
        }
        return fields;
    }

    hasValue(field) {
        return field && field !== "" ? true : false;
    }

    isPhone(field) {
        const phoneNumberPattern = /^(?!(\d)\(\1{3}\))(?!(\d)\2{9})(?!(\d)\3{2}.\3{3}.\3{4})(?:\(^[2-9]\d{2}\)|^[2-9]\d{2})(.?)?\d{3}\4\d{4}$/;
        return field && field.trim() && phoneNumberPattern.test(field);
    }

    isEmail(field) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return field && field.trim() && emailPattern.test(field);
    }

    isRxNumber(field) {
        const rxNumberPattern = /^((\d+)?(-{1})?\d+)+$/;
        return field.trim() && rxNumberPattern.test(field);
    }

    isZip(field) {
        const zipCodePattern = /^\d{5}$/;
        return field.trim() && zipCodePattern.test(field);
    }

    isFieldValid = (field) => {
        let value = this.state[field];
        if (field === "StreetNumber")
            value = this.state.mAddress ? this.state.mAddress.streetNumber : "";
        else if (field === "Street")
            value = this.state.mAddress ? this.state.mAddress.street : "";
        else if (field === "City")
            value = this.state.mAddress ? this.state.mAddress.city : "";
        else if (field === "State")
            value = this.state.mAddress ? this.state.mAddress.state : "";
        else if (field === "Zip")
            value = this.state.mAddress ? this.state.mAddress.zip : "";
        switch (field) {
            case "fName":
            case "lName":
            case "rStatus":
            case "StreetNumber":
            case "Street":
            case "City":
            case "State":
            case "gender":
                return this.hasValue(value);
            case "pNumber":
                return this.isPhone(value);
            case "email":
            case "confirmEmail":
                return this.isEmail(value);
            case "rNumber":
                return this.isRxNumber(value);
            case "mName":
                return true;
            case "zip":
            case "Zip":
                return this.isZip(value);
            case "mAddress":
                const { isShowManualAddress } = this.props;
                if (isShowManualAddress) {
                    const isStreetNumberValid = value.streetNumber !== '';
                    const isStreetValid = value.street !== '';
                    const isCityValid = value.city !== '';
                    const isStateValid = value.state !== '';
                    const isZipValid = value.zip !== '' && value.zip.length === 5;
                    return isStateValid && isStreetNumberValid && isStreetValid && isCityValid && isZipValid;
                }
                else {
                    if (value.zip)
                        return true;
                    else return false;
                }
            default:
                return true;
        }
    }

    validateEmailInputs() {
        const { email, confirmEmail, isemailValid, isconfirmEmailValid } = this.state;
        const { enableProxyRequestV2, isMinor, proxyRequestData, pharmacy, healthrecord } = this.props;
        if (enableProxyRequestV2 && !isMinor && (proxyRequestData.manageOwnHealthcare || (!proxyRequestData.manageOwnHealthcare && pharmacy))) {
            if (isemailValid && isconfirmEmailValid && email !== undefined && email !== null && confirmEmail !== undefined && confirmEmail !== null) {
                if (confirmEmail.toLowerCase() === email.toLowerCase() && confirmEmail.trim() !== "" && email.trim() !== "")
                    return true;
                else
                    return false;
            }
            return false;
        } else {
            return true;
        }

    }

    validateForm() {
        // this is from Continue Click
        const fieldsOnScreen = this.fieldsOnScreen();
        const newState = {};
        fieldsOnScreen.forEach(field => {
            newState[`is${field}Valid`] = this.isFieldValid(field);
        });

        this.setState(newState);
        return Object.keys(newState).every(function (key) { return newState[key]; }) && this.confirmEmail();;
    }

    onInputChange(field, value, isValid) {
        this.setState({ [field]: value, [`is${field}Valid`]: isValid });
    }

    confirmEmail() {
        const isValid = this.validateEmailInputs();
        return isValid;
    }

    notifyToEnterAddressManually() {
        this.props.handleManualAddressState(true);
    }

    render() {
        const { pNumber, mAddress, fName, mName, lName, rNumber, zip, rStatus, email, ispNumberValid, ismAddressValid, isfNameValid, ismNameValid, islNameValid, isrNumberValid, iszipValid, isrStatusValid, isemailValid, showAsInvalid, gender, isgenderValid, confirmEmail, isconfirmEmailValid } = this.state;
        const { minorRelationOptions, pharmacy, healthrecord, isMinor, isShowManualAddress, majorRelationOptions, enableProxyRequestV2, proxyRequestData, removeBSWPharmacy } = this.props;
        const className = (healthrecord ? 'col-md-4' : (pharmacy ? 'col-md-6' : ""));
        const relationshipClassName = (isShowManualAddress ? " col-md-6" : (healthrecord ? 'col-md-4' : 'col-sm-6'));
        const isConfirmedEmailMatching = this.confirmEmail();
        const showEmailDoNotMatch = enableProxyRequestV2 && !isConfirmedEmailMatching && isemailValid && isconfirmEmailValid;
        const emailandConfirmFields = <>
            <div className={"col-12 col-md form-group" + (isConfirmedEmailMatching ? " input-matches" : "")}>
                <Email placeholder="Email Address" id={emailInputId} value={email} name="email" required
                    onChange={(e, isValid) => { this.onInputChange('email', e.target.value, isValid); }}
                    showAsInvalid={(showAsInvalid && !isemailValid) || showEmailDoNotMatch}
                />
            </div>
            <div className={"col-12 col-md form-group" + (isConfirmedEmailMatching ? " input-matches" : "")}>
                <Email placeholder="Confirm Email Address" id="confirmEmailInput" value={confirmEmail} name="confirmEmail" required
                    onChange={(e, isValid) => { this.onInputChange('confirmEmail', e.target.value, isValid); }}
                    showAsInvalid={(showAsInvalid && !isconfirmEmailValid) || showEmailDoNotMatch}
                />
                {showEmailDoNotMatch &&
                    <div className="input-error-msg">Email addresses do not match</div>
                }
            </div>
        </>

        return (
            <div className="request-proxy-info-container" style={this.props.style}>
                <div className="row">
                    <div className="col-12 text-center">
                        <h1 className="step-heading step-heading-md">
                            {removeBSWPharmacy || (healthrecord && pharmacy)
                                ? "Whose records would you like to access?"
                                : !healthrecord && pharmacy ? `Whose pharmacy ${isMinor ? 'records' : 'account'} would you like to access?` : "Whose medical records would you like to access?"
                            }
                        </h1>
                        {(pharmacy) && <p>* Must match the person's current pharmacy records.</p>}
                    </div>
                </div>
                {enableProxyRequestV2 && !isMinor && proxyRequestData.manageOwnHealthcare
                    ? <div className="row step-form-container">
                        <div className="col-12">
                            <div className="row">
                                <div className={`col-12 col-md form-group`}>
                                    <GenericInput id={firstNameInputId} placeholder="First Name" value={fName} name="fName" required onChange={(e, v, isValid) => this.onInputChange('fName', v, isValid)} ref="fName" autoFocus showAsInvalid={showAsInvalid && !isfNameValid} />
                                </div>
                                <div className={`col-12 col-md form-group`}>
                                    <GenericInput id={lastNameInputId} placeholder="Last Name" value={lName} name="lName" required onChange={(e, v, isValid) => this.onInputChange('lName', v, isValid)} ref="lName" showAsInvalid={showAsInvalid && !islNameValid} />
                                </div>
                            </div>
                            <div className="row">
                                {emailandConfirmFields}
                                {pharmacy &&
                                    <div className={"col-12 col-md form-group"}>
                                        <PhoneNumber id={phoneInputId} required value={pNumber}
                                            onChange={(e, isValid) => { this.onInputChange('pNumber', e.target.value, isValid); }}
                                            placeholder="Phone Number"
                                            showAsInvalid={showAsInvalid && !ispNumberValid}
                                            ref="phone"
                                        />
                                    </div>
                                }
                            </div>
                            <div className="row">
                                {pharmacy && <>
                                    <div className="col-12 col-md form-group">
                                        <ZipCode id="zipCode" placeholder="Zip Code" value={zip != "" ? zip : mAddress.zip ? mAddress.zip : ''} name="zip" required onChange={(e, isValid) => { this.onInputChange('zip', e.target.value, isValid); }} ref="zipCode" showAsInvalid={this.state.showAsInvalid && !this.state.iszipValid} />
                                    </div>
                                    < div className={`col-12 col-md form-group`}>
                                        <Select
                                            id={relationInputId}
                                            name="rStatus"
                                            placeholder={"My Relationship to " + (isMinor ? "Minor" : "Patient")}
                                            required
                                            value={rStatus}
                                            options={isMinor ? minorRelationOptions : majorRelationOptions}
                                            //options={relationsToShow} //Todo: We need to add check for Major and Minor
                                            showAsInvalid={showAsInvalid && !isrStatusValid}
                                            onChange={(e, v, isValid) => this.onInputChange('rStatus', v, isValid)}
                                        />
                                    </div>
                                    <div className={"col-12 col-md form-group"}>
                                        <RxNumber rxNumberId={rxNumberInputId} value={rNumber} required placeholder="RX Number"
                                            onChange={(e, isValid) => { this.onInputChange('rNumber', e.target.value, isValid); }}
                                            tooltipID="activeRXToolTip" tooltipMsg="RX number from an active BSW prescription."
                                            showAsInvalid={showAsInvalid && !isrNumberValid}
                                        />
                                    </div></>
                                }
                            </div>
                        </div>
                    </div>
                    : <div className="row step-form-container">
                        <div className="col-12">
                            <div className="row">
                                {
                                    (healthrecord || pharmacy) &&
                                    <>  <div className={`col-12 form-group ${className}`}>
                                        <GenericInput id={firstNameInputId} placeholder="First Name" value={fName} name="fName" required onChange={(e, v, isValid) => this.onInputChange('fName', v, isValid)} ref="fName" autoFocus showAsInvalid={showAsInvalid && !isfNameValid}
                                        />
                                    </div>
                                        {healthrecord &&
                                            <div className="col-12 col-md-4 form-group">
                                                <GenericInput id={middleNameInputId} placeholder="Middle Name (optional)" value={mName} name="mName" onChange={(e, v, isValid) => this.onInputChange('mName', v, true)} ref="mName" showAsInvalid={false} />
                                            </div>
                                        }
                                        <div className={`col-12 form-group ${className}`}>
                                            <GenericInput id={lastNameInputId} placeholder="Last Name" value={lName} name="lName" required onChange={(e, v, isValid) => this.onInputChange('lName', v, isValid)} ref="lName" showAsInvalid={showAsInvalid && !islNameValid} />
                                        </div>
                                        {!isMinor && <div className="col-12">
                                            <div className="row">
                                                {enableProxyRequestV2 && !proxyRequestData.manageOwnHealthcare && pharmacy
                                                    ? <>{emailandConfirmFields}</>
                                                    : <div className={"col-12 form-group col-sm"}>
                                                        <Email placeholder="Email Address" id={emailInputId} value={email} name="email" required
                                                            onChange={(e, isValid) => { this.onInputChange('email', e.target.value, isValid); }}
                                                            showAsInvalid={showAsInvalid && !this.state.isemailValid}
                                                        />
                                                    </div>
                                                }
                                                <div className={"col-12 form-group" + (enableProxyRequestV2 && !proxyRequestData.manageOwnHealthcare && pharmacy ? " col-md" : " col-sm")}>
                                                    <PhoneNumber id={phoneInputId} required value={pNumber}
                                                        onChange={(e, isValid) => { this.onInputChange('pNumber', e.target.value, isValid); }}
                                                        placeholder="Phone Number"
                                                        showAsInvalid={showAsInvalid && !ispNumberValid}
                                                        ref="phone"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        {healthrecord ?
                                            <React.Fragment>
                                                {healthrecord &&
                                                    <div className={`col-12 ${!isShowManualAddress ? " col-md-4" : " col-md-6"} form-group`}>
                                                        <Select
                                                            id="gender"
                                                            name="gender"
                                                            placeholder="Gender"
                                                            required
                                                            value={gender}
                                                            options={genderOptions}
                                                            showAsInvalid={showAsInvalid && !isgenderValid}
                                                            onChange={(e, v, isValid) => this.onInputChange('gender', v, isValid)}
                                                        />
                                                    </div>
                                                }
                                                <div className={`col-12 col-md-4 form-group mailing-address-input-container ${!isShowManualAddress ? "" : "hidden"} `}>
                                                    <LocationSearchInput
                                                        placeholder="Mailing Address" required id={addressInputId}
                                                        notifyToEnterAddressManually={this.notifyToEnterAddressManually}
                                                        onChange={(address, components) => {
                                                            if (components) {
                                                                this.setState(
                                                                    {
                                                                        mAddress: components,
                                                                        ismAddressValid: true,
                                                                        zip: components.zip ? components.zip : "",
                                                                        iszipValid: components.zip ? true : false
                                                                    });
                                                            }
                                                            else {
                                                                this.setState(
                                                                    {
                                                                        mAddress: {
                                                                            streetNumber: '',
                                                                            street: '',
                                                                            street2: '',
                                                                            city: '',
                                                                            state: 'TX',
                                                                            zip: ''
                                                                        },
                                                                        ismAddressValid: false,
                                                                        zip: '',
                                                                        iszipValid: false,
                                                                        isStateValid: true
                                                                    });
                                                            }
                                                        }
                                                        }
                                                        showAsInvalid={this.state.showAsInvalid && !ismAddressValid}
                                                        address={mAddress}
                                                        ref="address"
                                                    />
                                                </div>
                                            </React.Fragment> : pharmacy && !healthrecord && <div className="col-12 col-sm-6 form-group">
                                                <ZipCode id="zipCode" placeholder="Zip Code" value={zip != "" ? zip : mAddress.zip ? mAddress.zip : ''} name="zip" required onChange={(e, isValid) => { this.onInputChange('zip', e.target.value, isValid); }} ref="zipCode" showAsInvalid={this.state.showAsInvalid && !this.state.iszipValid} />
                                            </div>
                                        }
                                        <div className={`col-12 form-group ${relationshipClassName} `}>
                                            <Select
                                                id={relationInputId}
                                                name="rStatus"
                                                placeholder={"My Relationship to " + (isMinor ? "Minor" : "Patient")}
                                                required
                                                value={rStatus}
                                                options={isMinor ? minorRelationOptions : majorRelationOptions}
                                                //options={relationsToShow} //Todo: We need to add check for Major and Minor
                                                showAsInvalid={showAsInvalid && !isrStatusValid}
                                                onChange={(e, v, isValid) => this.onInputChange('rStatus', v, isValid)}
                                            />
                                        </div>
                                    </>}
                            </div>
                            {isShowManualAddress && healthrecord && <>
                                <div className="row manual-mailing-address-input-container">
                                    <div className="col-12 col-md-2 form-group">
                                        <GenericInput required value={mAddress.streetNumber}
                                            onChange={(e, value, isValid) => { this.setState({ mAddress: { ...mAddress, streetNumber: e.target.value }, isStreetNumberValid: isValid }); }}
                                            placeholder="Street Number"
                                            showAsInvalid={this.state.showAsInvalid && !this.state.isStreetNumberValid}
                                        />
                                    </div>
                                    <div className="col-12 col-md-4 form-group">
                                        <GenericInput required value={mAddress.street}
                                            onChange={(e, value, isValid) => { this.setState({ mAddress: { ...mAddress, street: e.target.value }, isStreetValid: isValid }); }}
                                            placeholder="Street Name"
                                            showAsInvalid={this.state.showAsInvalid && !this.state.isStreetValid}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6 form-group">
                                        <GenericInput value={mAddress.street2} onChange={(e) => { this.setState({ mAddress: { ...mAddress, street2: e.target.value } }); }} placeholder="Street Address 2 (optional)" />
                                    </div>
                                    <div className="col-12 col-md-5 form-group">
                                        <GenericInput required value={mAddress.city}
                                            onChange={(e, value, isValid) => { this.setState({ mAddress: { ...mAddress, city: e.target.value }, isCityValid: isValid }); }}
                                            placeholder="City"
                                            showAsInvalid={this.state.showAsInvalid && !this.state.isCityValid}
                                        />
                                    </div>
                                    <div className="col-12 col-md-4 form-group">
                                        <Select required value={mAddress.state}
                                            onChange={(e, value, isValid) => { this.setState({ mAddress: { ...mAddress, state: e.target.value }, isStateValid: isValid }); }}
                                            options={Tools.getStates()} placeholder="State"
                                            showAsInvalid={this.state.showAsInvalid && !this.state.isStateValid}
                                        />
                                    </div>
                                    <div className="col-12 col-md-3 form-group">
                                        <ZipCode placeholder="Zip" value={mAddress.zip} name="zipCode" required
                                            onChange={(e, isValid) => { this.setState({ mAddress: { ...mAddress, zip: e.target.value }, isZipValid: isValid }); }}
                                            showAsInvalid={this.state.showAsInvalid && !this.state.isZipValid}
                                        />
                                    </div>
                                </div>
                            </>}
                            <div className="row">
                                {(pharmacy && isMinor) &&
                                    <div className={"col-12 form-group col-sm-6"}>
                                        <PhoneNumber id={phoneInputId} required value={pNumber}
                                            onChange={(e, isValid) => { this.onInputChange('pNumber', e.target.value, isValid); }}
                                            placeholder="Phone Number"
                                            showAsInvalid={showAsInvalid && !ispNumberValid}
                                            ref="phone"
                                        />
                                    </div>
                                }
                                {pharmacy &&
                                    <div className={"col-12 form-group" + (!isMinor ? " col-sm-12" : " col-sm-6")}>
                                        <RxNumber rxNumberId={rxNumberInputId} value={rNumber} required placeholder="RX Number"
                                            onChange={(e, isValid) => { this.onInputChange('rNumber', e.target.value, isValid); }}
                                            tooltipID="activeRXToolTip" tooltipMsg="RX number from an active BSW prescription."
                                            showAsInvalid={showAsInvalid && !isrNumberValid}
                                        />
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ProxyInfo);